module.exports = __webpack_public_path__ + "static/media/Consultousleep.f722030e.png";